import React from 'react';

import think3 from '../../imgs/think3.png';
import magnet from '../../imgs/magnet.png';

export default class Train2 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
    <h1>Явление сверхпроводимости</h1>
<p>
    Явление сверхпроводимости открыл в 1911 г. Хейке Камерлинг-Оннес. Суть его
    состояла в том, что некоторые вещества при охлаждении до температуры ниже
    20 К (20° выше абсолютного нуля) теряют всякое электрическое сопротивление.
    Как правило, при охлаждении металла его электрическое сопротивление
    постепенно уменьшается.
</p>

    <h1>ПОДУМАЙ:</h1>
    <blockquote>
     Почему при охлаждении металла его электрическое сопротивление постепенно
     уменьшается?
   </blockquote>
   <p align='center'>
     <img src={think3}/>
   </p>
<p>
    Но Камерлинг-Оннес, к собственному изумлению, обнаружил, что сопротивление
    некоторых материалов при определенной критической температуре резко падает
    до нуля.
</p>
<p>
    Физики сразу поняли важность полученного результата. При передаче на
    большие расстояния в линиях электропередачи теряется значительное
    количество электроэнергии. Но если бы сопротивление удалось устранить,
    электроэнергию можно было бы передавать в любое место почти даром. Вообще,
    возбужденный в замкнутом контуре электрический ток мог бы циркулировать в
    нем без потерь энергии миллионы лет. Более того, из этих необычайных токов
    несложно было бы создать магниты невероятной мощности. А имея такие
    магниты, можно было бы без усилий поднимать громадные грузы.
</p>
<p>
    Несмотря на чудесные возможности сверхпроводников, применять их очень
    непросто. Держать большие магниты в баках с чрезвычайно холодными
    жидкостями очень дорого. Чтобы сохранять жидкости холодными, потребуются
    громадные фабрики холода, которые поднимут стоимость сверхпроводящих
    магнитов до заоблачных высот и сделают их использование невыгодным.
</p>
<p>
    Но в 1986 г. был открыт новый класс веществ, получивших название
    «высокотемпературные сверхпроводники»; эти вещества обретали
    сверхпроводимость при температурах порядка 90° выше абсолютного нуля, или
    90 К.
</p>
<p>
    В настоящее время мировой рекорд для высокотемпературных сверхпроводников
    принадлежит веществу, представляющему собой сложный оксид меди, кальция,
    бария, таллия и ртути, которое становится сверхпроводящим при 138 К (-135
    °С). Эта относительно высокая температура все еще очень далека от
    комнатной. Но и это—важный рубеж. Азот становится жидким при температуре 77
    К, а жидкий азот стоит примерно столько же, сколько обычное молоко. Поэтому
    для охлаждения высокотемпературных сверхпроводников можно использовать
    обычный жидкий азот, это недорого.
</p>
  <p align='center'>
    <img src={magnet} />
  </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Train-2.js